<template>
    <component :is="layout">
        <transition-page>
            <router-view :key="$route.fullPath" />
        </transition-page>
    </component>
</template>

<script>
import TransitionPage from '@/components/utility/TransitionPage';
import SyncEngine from '@/database/_Sync';
import DBTireSize from '@/database/TireSize';
import DBCar from '@/database/Car';
import DBCarTireSize from '@/database/CarTireSize';
import DBMasterProduct from '@/database/MasterProduct';
import Helper from '@/resources/Helper';

const default_layout = 'default';

export default {
    data() {
        return {
            appVersion: localStorage.appVersion || 0
        };
    },
    components: {
        TransitionPage
    },
    created() {
        document.addEventListener('appUpdateEvent', (event) => {
            if (event.detail.isVersionUpdate) {
                this.popupUpdateVersion();
            }
        });
    },
    mounted() {
        this.checkUpdateVersion();
        this.syncData();

        console.log('Current Version: ' + this.appVersion);

        setInterval(() => {
            this.checkUpdateVersion();
            this.syncData();
        }, 600000); // Check every 10 minutes
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + '-layout';
        }
    },
    methods: {
        syncData() {
            // Master Data
            DBTireSize.sync();
            DBCar.sync();
            DBCarTireSize.sync();
            DBMasterProduct.sync();

            // Sync Pipeline
            SyncEngine.sendSyncData();
        },
        async checkUpdateVersion() {
            // Check Data with API
            const serverVersion = await Helper.getAPI(Helper.getApiUrl(), '/api/app/check-web-version');

            if (serverVersion) {
                if (serverVersion.data.version > this.appVersion) {
                    localStorage.appVersion = serverVersion.data.version;
                    this.popupUpdateVersion();
                }
            }
        },
        popupUpdateVersion() {
            this.$swal({
                title: 'มีการปรับปรุงเวอชั่นของระบบ โปรดคลิกเพื่อทำการอัพเดต',
                icon: 'info',
                allowOutsideClick: false,
                confirmButtonText: 'อัพเดต'
            }).then(() => {
                location.reload();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>